<template>
    <div id="container"></div>
    <Loading :active="isLoading" class="text-center" color="#000000" loader="spinner"></Loading>
</template>

<script>
import {mapActions} from 'vuex';
import config from '@/config/prod.env';
import Loading from "vue3-loading-overlay";
import * as pbi from "powerbi-client";
export default {
    name: "TheReportViewer",
    components: {
        Loading
    },
    data() {
    return {
        isLoading: true,
        reportId: null,
        report: null,
        streamFileUrl: null,
        user: null,
        reportConfig: {}
    }
    },
    methods: {
        ...mapActions('report', ['getReportById']),
        setup() {
            this.streamFileUrl = process.env.VUE_APP_STREAM_FILE_URL;
            this.reportId = this.$route.query.reportId;

            this.user = JSON.parse(localStorage.getItem('login_info'));
        },
        async getData() {
            // get report
            let rs = await this.getReportById(this.reportId);
            if(rs.isOk) {
                this.report = rs.data.data;
                if(this.report.isWebUrl) {
                    window.location.href = this.report.webUrl;
                }
                document.title = this.report.reportName;
            }
            this.isLoading = false;
        }
    },
    async mounted() {
        this.setup();
        await this.getData();


        // embed power bi
        const config = {
            type: 'report',
            reportId: this.report.id,
            accessToken: this.user.pbiAccessToken.access_token,
            embedUrl: this.report.pbiEmbedUrl,
            pageView: 'fitToWidth',
            permissions: pbi.models.Permissions.All,
            filterPaneEnabled: false,
            background: pbi.models.BackgroundType.Transparent,
            settings: {
                filterPaneEnabled: false,
                navContentPaneEnabled: true,
                customLayout:
                {
                    displayOption: pbi.models.DisplayOption.FitToPage
                }
                
            }
        };

        let powerbi = new pbi.service.Service(
            pbi.factories.hpmFactory, 
            pbi.factories.wpmpFactory, 
            pbi.factories.routerFactory
        );

        const dashboardContainer = document.getElementById('container');
        const dashboard = powerbi.embed(dashboardContainer, config);

        // dashboard.off("loaded");
        // dashboard.off("rendered");
        // dashboard.on("error", function () {
        //     this.dashboard.off("error");
        // });
    },
    created() {
        
    }
};
</script>
  
  
  
  
<style>
    @import url("https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback"); 
    *{
        margin: 0;
        padding: 0;
    } 
    #container {
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    #container iframe {
        border: none;
    }
</style>
  